import {
  analyticsDatastore
} from "./chunk-BXHN3TEF.mjs";
import {
  offlineDatastore
} from "./chunk-AROJUVFE.mjs";

// src/datastores/analytics-datastore/initialize-analytics-datastore.ts
function initializeAnalyticsDatastore(config) {
  if (typeof window !== "undefined") {
    if (window.yvaDatastore) {
      if (!window.yvaDatastore.config) {
        window.yvaDatastore.config = config;
      }
      if (!window.yvaDatastore.contexts) {
        window.yvaDatastore.contexts = {};
        window.yvaDatastore.currentContextId = null;
      }
      if (!window.yvaDatastore.events || !Array.isArray(window.yvaDatastore.events)) {
        window.yvaDatastore.events = [];
      }
      if (!window.yvaDatastore.state) {
        window.yvaDatastore.state = {};
      }
    } else {
      window.yvaDatastore = analyticsDatastore(config);
    }
    offlineDatastore.read().then((possibleOfflineDatastore) => {
      if (possibleOfflineDatastore) {
        if (Object.keys(possibleOfflineDatastore.contexts).length) {
          Object.entries(possibleOfflineDatastore.contexts).forEach(([contextId, context]) => {
            if (window.yvaDatastore && !window.yvaDatastore.contexts[contextId]) {
              window.yvaDatastore.contexts[contextId] = context;
            }
          });
        }
        if (possibleOfflineDatastore.events.length) {
          possibleOfflineDatastore.events.forEach((offlineEvent) => {
            if (window.yvaDatastore && window.yvaDatastore.contexts[offlineEvent.contextId] && !window.yvaDatastore.events.some((liveEvent) => liveEvent.data.eventId === offlineEvent.data.eventId)) {
              window.yvaDatastore.events.push(offlineEvent);
            }
          });
        }
      }
    }).catch((error) => {
      if (window.yvaDatastore && window.yvaDatastore.config.debug) {
        console.error("Error initializing from offline datastore");
        console.dir(error, { depth: null });
      }
    });
  }
}

export {
  initializeAnalyticsDatastore
};
